// @ts-nocheck

import { filter, size } from 'lodash';
import { createSelector } from 'reselect';

import { getItemIdFromProps } from '../../selectors/_propsGetters_';
import {
  selectBasketEligibleBonuses,
  selectBasketMode,
  selectBasketSelectedBonusId,
} from '../../selectors/basket/basketPrimary.selector';
import {
  selectBasketShowResume,
  selectBasketIsInputDisabled,
  makeBasketItemIsValidatedSelector,
  makeBasketItemSelector,
} from '../../selectors/basketCommon.selector';
import { selectBasketEnhancedItems } from '../../selectors/basketItems.selector';
import { BasketModes } from '../../types/basket';

const makeBonusListPropsSelector = () => {
  const getIsVisible = createSelector(
    [
      selectBasketMode,
      selectBasketShowResume,
      selectBasketEnhancedItems,
      getItemIdFromProps,
      makeBasketItemIsValidatedSelector(),
    ],
    (mode, showResume, items, itemIdModeSimple, isItemIsValidated) => {
      const isModeSimple = mode === BasketModes.SIMPLE;
      const isModeSystem = mode === BasketModes.SYSTEM;
      const isOneSimpleBet = isModeSimple && items.length === 1;
      const isMultipleSimpleBets = isModeSimple && items.length > 1;
      return (
        !isItemIsValidated &&
        !isModeSystem &&
        !showResume &&
        ((isOneSimpleBet && !itemIdModeSimple) ||
          (!isModeSimple && !itemIdModeSimple) ||
          (isMultipleSimpleBets && itemIdModeSimple))
      );
    },
  );

  return createSelector(
    [
      selectBasketMode,
      selectBasketEligibleBonuses,
      selectBasketSelectedBonusId,
      selectBasketEnhancedItems,
      selectBasketShowResume,
      selectBasketIsInputDisabled,
      makeBasketItemSelector(),
      getIsVisible,
    ],
    (mode, basketEligibleBonuses, basketSelectedBonusId, items, showResume, isDisabled, item, isVisible) => {
      const isModeSimple = mode === BasketModes.SIMPLE;

      let itemId = null;
      let eligibleBonuses = basketEligibleBonuses;
      let selectedBonusId = basketSelectedBonusId;
      let bonuses = [];

      if (isVisible) {
        if (item) {
          itemId = item.oddId;
          eligibleBonuses = item.eligibleBonuses;
          selectedBonusId = item.selectedBonusId;
        }

        bonuses = filter(eligibleBonuses, (eligible) => {
          if (!eligible.deleted) {
            if (!isModeSimple) return true;
            if (size(filter(items, (i) => i.selectedBonusId === eligible.promotionId)) === 0) return true;
            if (eligible.promotionId === selectedBonusId) return true;
          }
          return false;
        }).map(({ title, promotionId }) => ({
          label: title,
          id: promotionId,
        }));
      }

      // FIXME allow with freebet ?

      return {
        itemId,
        selectedBonusId,
        bonuses,
        isDisabled,
      };
    },
  );
};

export default makeBonusListPropsSelector;
